import ExternalBankAccountsSection, {
  IBankAccountSectionProps,
} from "./ExternalBankAccountsSection";

export default ExternalBankAccountsSection;
export type { IBankAccountSectionProps };
